import * as ActionTypes from '../constants/ActionTypes';

const INITIAL_STATE = {
	dialogs: [],
	editmodal: [],
};

const setDialogs = (state, payload) => {
	let dialogs = [...state.dialogs];

	if (dialogs.length === 0) {
		dialogs.push(payload);
	} else {
		dialogs = [payload, ...dialogs];
	}
	return { ...state, dialogs };
};

const setEditModal = (state, payload) => {
	const editmodal = { ...payload };
	return { ...state, editmodal };
};

export default (
	state = INITIAL_STATE,
	{ type, payload }: { type: string; payload: any }
) => {
	switch (type) {
		case ActionTypes.SHOW_DIALOG:
			console.log(payload);
			return setDialogs(state, payload);
		case ActionTypes.SHOW_MODAL:
			console.log(payload);
			return setEditModal(state, payload);
		default:
			return state;
	}
};
